// extracted by mini-css-extract-plugin
export var container = "_2z-0";
export var error = "_2z-9";
export var label = "_2z-5";
export var light = "_2z-6";
export var md = "_2z-3";
export var sm = "_2z-2";
export var thin = "_2z-8";
export var thinBold = "_2z-7";
export var vertical = "_2z-4";
export var xs = "_2z-1";